/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-21 15:41:43
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-20 17:15:37
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/ContentPage/index.tsx
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */

import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import ContentGroup from 'src/constrains/DraggableModules/ContentGroup';

import {
  getCollapseOpenStatus,
  getCollapseStatus,
  getCollapseValidationMsgDisplay,
  getContent,
  getOpeningCollapse,
  getOrder,
  getVisibleCollapse,
  moduleContentDynamicOnChange,
  moduleContentOnChange,
  moduleContentStaticOnChange,
  onCollapseOpen,
  onErrorChange,
  onModuleTypeChange,
  onDuplicate,
} from '../slice';

//import { productsInit } from '@/src/request/product/product'; //暂时link

const ContentPage = (props) => {
  const _d = useDispatch();
  const order = useSelector(getOrder());

  const handleOnModuleContentStaticChange = (obj) => {
    _d(moduleContentStaticOnChange(obj));
  };

  const handleOnModuleContentDynamicChange = (obj) => {
    _d(moduleContentDynamicOnChange(obj));
  };

  const handleOnModuleOrderListChange = (obj) => {
    _d(moduleContentOnChange(obj));
  };

  const handleOnCollapseOpen = (idArr) => {
    _d(onCollapseOpen({ idArr }));
  };

  const handleOnModuleTypeChange = (data) => {
    _d(onModuleTypeChange(data));
  };
  // const fetchData = () => {};
  const handleOnDuplicate = (data) => {
    _d(onDuplicate(data));
  };

  return (
    <ContentGroup
      disabled={props.disabled}
      getCollapseOpenStatus={getCollapseOpenStatus}
      onCollapseOpen={handleOnCollapseOpen}
      getOpeningCollapse={getOpeningCollapse}
      getContent={getContent}
      droppableId={'SalesChannelEditorHomepage'}
      data={order}
      onOrderListOnChange={handleOnModuleOrderListChange}
      onDynamicChange={handleOnModuleContentDynamicChange}
      onStaticChange={handleOnModuleContentStaticChange}
      linkSet={props.linkSet}
      getErrorDisplay={getCollapseValidationMsgDisplay}
      onErrorChange={onErrorChange}
      getVisibleCollapse={getVisibleCollapse}
      getCollapseStatus={getCollapseStatus}
      onModuleTypeChange={handleOnModuleTypeChange}
      extraProps={props.extraProps}
      onDuplicate={handleOnDuplicate}
      allDisabled={props.allDisabled}
      hideEdit={false}
    />
  );
};

export default ContentPage;
